import React, { Component } from 'react'
// import PropTypes from 'prop-types'
import { connect } from 'react-redux'

export class WelcomeScreen extends Component {
  static propTypes = {
    // prop: PropTypes
  }

  render() {
    return (
      <div>
        
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  
})

const mapDispatchToProps = {
  
}

export default connect(mapStateToProps, mapDispatchToProps)(WelcomeScreen)



// WEBPACK FOOTER //
// ./src/components/WelcomeScreen.js